import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountSectionCardComponent } from './account-section-card';
import { GalleryCategory } from './accounts-information.models';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-account-gallery-section',
  standalone: true,
  imports: [CommonModule, AccountSectionCardComponent, TranslatePipe],
  template: `
    <app-account-section-card [title]="'accountsInformation.sections.gallery' | translate" iconClass="fa-solid fa-images">
      <div class="space-y-8 antialiased">
        @for (category of categories; track category.title) {
          <div class="space-y-3.5">
            <h3
              class="text-xs font-black uppercase tracking-widest text-text-muted font-mono flex items-center gap-2"
            >
              <div
                class="w-6 h-6 rounded-md bg-primary/10 border border-primary/20 flex items-center justify-center text-primary"
              >
                <i [class]="category.iconClass || 'fa-solid fa-folder-open'"></i>
              </div>
              <span class="text-text-primary font-black">
                {{ category.title.startsWith('accountsInformation.') ? (category.title | translate) : category.title }}
              </span>
            </h3>

            <div class="grid grid-cols-2 md:grid-cols-3 gap-3.5">
              @for (photo of category.photos; track photo.src; let i = $index) {
                <button
                  type="button"
                  class="relative rounded-2xl overflow-hidden group cursor-pointer border border-border-subtle bg-surface-hover shadow-sm focus:outline-none focus:ring-2 focus:ring-primary/40 transition-all duration-300"
                  [ngClass]="{
                    'col-span-2 md:col-span-2 h-48 md:h-56': i === 0,
                    'col-span-1 h-48 md:h-56': i !== 0,
                  }"
                >
                  <img
                    [src]="photo.src"
                    [alt]="photo.alt.startsWith('accountsInformation.') ? (photo.alt | translate) : (photo.alt || ('accountsInformation.gallery.defaultAlt' | translate))"
                    class="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    loading="lazy"
                  />

                  <div
                    class="absolute inset-0 bg-gradient-to-t from-bg-base/40 via-transparent to-transparent opacity-40 group-hover:opacity-100 transition-opacity duration-300"
                  ></div>

                  <div
                    class="absolute inset-0 bg-bg-base/20 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center justify-center gap-2"
                  >
                    <div
                      class="w-10 h-10 rounded-full bg-surface/20 backdrop-blur-md border border-border flex items-center justify-center text-text-primary translate-y-2 group-hover:translate-y-0 transition-transform duration-300 shadow-lg"
                    >
                      <i class="fa-solid fa-magnifying-glass-plus text-sm"></i>
                    </div>
                    <span
                      class="text-[10px] font-black uppercase tracking-wider text-text-primary drop-shadow-sm font-mono translate-y-2 group-hover:translate-y-0 transition-transform duration-300 delay-75"
                    >
                      {{ 'accountsInformation.actions.expandAsset' | translate }}
                    </span>
                  </div>

                  @if (photo.alt) {
                    <div
                      class="absolute bottom-3 left-3 bg-surface/60 backdrop-blur-md px-2.5 py-1 rounded-lg border border-border text-[10px] font-bold text-text-primary max-w-[80%] truncate opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none"
                    >
                      {{ photo.alt.startsWith('accountsInformation.') ? (photo.alt | translate) : photo.alt }}
                    </div>
                  }
                </button>
              }
            </div>
          </div>
        } @empty {
          <div
            class="py-12 flex flex-col items-center justify-center border border-dashed border-border-subtle rounded-2xl bg-surface-elevated text-center font-mono"
          >
            <div
              class="w-12 h-12 rounded-xl bg-surface-hover flex items-center justify-center text-text-muted mb-3"
            >
              <i class="fa-solid fa-images text-lg"></i>
            </div>
            <span class="text-[11px] font-black uppercase tracking-widest text-text-muted"
              >{{ 'accountsInformation.empty.gallery' | translate }}</span
            >
          </div>
        }
      </div>
    </app-account-section-card>
  `,
})
export class AccountGallerySectionComponent {
  @Input() categories: GalleryCategory[] = [];
}
